"use client"

export default function CourseTargetAudience() {
  const audiences = [
    {
      icon: "/course/product-manager.webp",
      title: "Product Managers and Strategists",
      description:
        "You bridge business goals with technical execution. You want to learn how to translate product requirements into AI agent capabilities, define success metrics, and collaborate effectively with technical teams.",
    },
    {
      icon: "/course/technical-architects.webp",
      title: "Technical Architects and Data Scientists",
      description:
        "You already understand data pipelines and model basics. You want to learn how to integrate language models into agent workflows.",
    },
    {
      icon: "/course/technical-consultants.webp",
      title: "Technical Consultants and Strategists",
      description:
        "You advise clients on AI roadmaps or make decisions about AI investments. You need a deep understanding about Agentic systems.",
    },
    {
      icon: "/course/tech-leads.webp",
      title: "Tech Leads and Backend Developers",
      description:
        "You need to coordinate multiple services and agents in your organization. You want to learn best practices for orchestration and others.",
    },
  ]

  return (
    <section className="relative py-16 bg-gray-950">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-green-500 text-lg font-medium mb-4 font-montserrat">Prerequisites</h2>
          <div className="flex justify-center items-center mb-8">
            <div className="w-16 h-1 bg-green-500"></div>
            <div className="w-4 h-4 bg-white rounded-full ml-2"></div>
          </div>
          <h3 className="text-white text-4xl lg:text-5xl font-bold font-montserrat">Who should take this course?</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {audiences.map((audience, index) => (
            <div key={index} className="bg-gray-900/50 border-2 border-green-500 rounded-lg p-8 text-center">
              <div className="flex justify-center mb-6">
                <img src={audience.icon || "/placeholder.svg"} alt={audience.title} width={48} height={48} className="w-12 h-12" />
              </div>
              <h4 className="text-white text-xl font-bold mb-4 font-montserrat leading-tight">{audience.title}</h4>
              <p className="text-gray-300 text-base leading-relaxed font-vietnam">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
